import { render, staticRenderFns } from "./KetQuaKinhDoanh.vue?vue&type=template&id=117e7138&"
import script from "./KetQuaKinhDoanh.vue?vue&type=script&lang=js&"
export * from "./KetQuaKinhDoanh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports